// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner[data-v-39b1a1fb]{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite}", ""]);
// Exports
module.exports = exports;
